import { CircleCheckBig, CircleDashed, CircleX, type LucideIcon } from 'lucide-react';
import { APPROVAL_STATUS_TONE, type StatusColorTone } from '@/styles/statusColors';

export const FEEDBACK_STATUS = ['pending', 'in_progress', 'completed', 'rejected'] as const;

export const FEEDBACK_STATUS_LABELS: Record<(typeof FEEDBACK_STATUS)[number], string> = {
  pending: 'Pending',
  in_progress: 'In Progress',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const FEEDBACK_STATUS_TONE: Record<(typeof FEEDBACK_STATUS)[number], StatusColorTone> = {
  pending: APPROVAL_STATUS_TONE.pending,
  in_progress: 'info',
  completed: 'success',
  rejected: APPROVAL_STATUS_TONE.rejected,
};

export const RESOLVE_STATUS_ICONS: Record<'in_progress' | 'completed' | 'rejected', LucideIcon> = {
  in_progress: CircleDashed,
  completed: CircleCheckBig,
  rejected: CircleX,
};

export const RESOLVE_SUBMIT_LABELS: Record<'in_progress' | 'completed' | 'rejected', string> = {
  in_progress: 'Mark In Progress',
  completed: 'Mark Completed',
  rejected: 'Reject Feedback',
};

export const ADMIN_MESSAGE_MAX = 1000;

export const DEFAULT_PAGE_SIZE = 20;
